import { render, staticRenderFns } from "./PacientesEmAtendimento.vue?vue&type=template&id=2e278d93&scoped=true"
import script from "./PacientesEmAtendimento.vue?vue&type=script&lang=js"
export * from "./PacientesEmAtendimento.vue?vue&type=script&lang=js"
import style0 from "./PacientesEmAtendimento.vue?vue&type=style&index=0&id=2e278d93&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e278d93",
  null
  
)

export default component.exports